import Container from "react-bootstrap/Container";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./LoadingContainer.css";

export default function LoadingContainer() {
  return (
    <Container>
      <Row>
        <SkeletonTheme baseColor="#f7f7f7" highlightColor="#eeeeee">
          <Col className="align-items-center d-flex flex-column">
            <Skeleton count={1} className="loading-container-card" />
          </Col>
          <Col className="align-items-center d-flex flex-column">
            <Skeleton count={1} className="loading-container-card" />
          </Col>
          <Col className="align-items-center d-flex flex-column">
            <Skeleton count={1} className="loading-container-card" />
          </Col>
        </SkeletonTheme>
      </Row>
    </Container>
  );
}
